import { useCallback, useState } from 'react';

import { adminLocalizationKeys } from '@/api';
import { ConstructorApi } from '../api';
import { queryClient } from '@/app/QueryClientProvider';
import { usePopups } from '@/hooks';

export const useDocumentType = () => {
  const { showSuccessToast, showErrorToast } = usePopups();
  const [isCreating, setIsCreating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCreate = useCallback(async (questionSectionTypeId, kycTypeDocumentId) => {
    try {
      setIsCreating(true);
      const result = await ConstructorApi.addDocumentType(questionSectionTypeId, kycTypeDocumentId);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllQuestionnaires]
        });
        showSuccessToast('Created');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsCreating(false);
    }
  }, []);

  const handleDelete = useCallback(async (questionSectionTypeId, kycTypeDocumentId) => {
    try {
      setIsDeleting(true);
      const result = await ConstructorApi.deleteDocumentType(
        questionSectionTypeId,
        kycTypeDocumentId
      );
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllQuestionnaires]
        });
        showSuccessToast('Created');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return {
    handleCreate,
    handleDelete,
    isCreating,
    isDeleting
  };
};
